import type { ResourceConfig } from "../types";

export const studentConfig = {
  displayName: "学员",
  category: "student",
  permissions: {
    "read:all": {
      label: "查看所有学员",
      description: "可以查看系统中所有学员的信息",
    },
    "write:all": {
      label: "编辑所有学员",
      description: "可以编辑系统中所有学员的信息",
    },
    "read:assigned": {
      label: "查看自己负责的学员",
      description: "只能查看分配给自己的学员信息",
    },
    "write:assigned": {
      label: "编辑自己负责的学员",
      description: "只能编辑分配给自己的学员信息",
    },
  },
  navigation: {
    path: "/students",
    label: "学员",
    icon: "Users" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    order: 40,
  },
} satisfies ResourceConfig;
